var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    _vm._b(
      {
        attrs: {
          "invalid-feedback": _vm.invalidFeedback,
          label: _vm.label,
          "label-for": _vm.formControlId,
        },
      },
      "b-form-group",
      _vm.$attrs,
      false
    ),
    [
      _c("b-form-select", {
        attrs: {
          id: _vm.formControlId,
          disabled: _vm.isReadOnlyProperty || _vm.dependencyDisabled,
          name: _vm.formControlId,
          options: _vm.internalOptions,
          required: _vm.isRequiredProperty,
          state: _vm.validationState,
        },
        on: {
          change: function ($event) {
            return _vm.$emit("change")
          },
          focus: _vm.ensureOptionsLoaded,
        },
        model: {
          value: _vm.data[_vm.property],
          callback: function ($$v) {
            _vm.$set(_vm.data, _vm.property, $$v)
          },
          expression: "data[property]",
        },
      }),
      _vm._v(" "),
      _vm.loadingOptions ? _c("csp-loading-indicator") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }